/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 25.07.2016.
 */

import Settings from './settings';

export default Settings;



// WEBPACK FOOTER //
// ./src/containers/Settings/index.js